import React, { FC, ReactNode } from "react"
import { Button, IconInfo, IconWarn } from "dash-styled"

interface BannerProps {
    icon: "info" | "warn"
    className?: string
    children: ReactNode
    actions?: { label: string; onClick: () => void; isLoading?: boolean }[]
}

export const Banner: FC<BannerProps> = ({
    icon,
    className,
    children,
    actions
}) => {
    const Icon = icon === "info" ? IconInfo : IconWarn

    return (
        <div
            className={`rounded-md p-2 bg-smoke-40 text-rhino-800 flex items-start ${
                className ?? ""
            }`}
        >
            <Icon size="md" className="text-smoke-350 m-1 mr-2" />
            <p className="mt-1">{children}</p>
            <div className="flex items-center flex-1 justify-end">
                {actions?.map(({ label, onClick, isLoading }) => (
                    <Button
                        variant="contained"
                        color="plain"
                        className="w-max-content p-2 mr-2"
                        onClick={onClick}
                        disabled={isLoading}
                        key={label}
                        testId={`banner-button-${label.toLowerCase()}`}
                    >
                        {label}
                    </Button>
                ))}
            </div>
        </div>
    )
}
